import { css } from '@emotion/react';
import { colors } from '#themes/stena-recycling';
import { boxShadow, clipPathBottom, clipPathTop } from '../../../../helpers/styleHelpers';

export const styles = {
  Positioner: css`
    outline: 0;
    /* Portaled to body, so it must stack above page content and the Modal and Drawer overlays (100). */
    z-index: 101;
  `,
  Popup: css`
    box-sizing: border-box;
    border-radius: 0.25rem;
    border: 1px solid #e6e6e6;
    background-color: canvas;
    display: flex;
    flex-direction: column;
    width: var(--anchor-width);
    max-height: min(23rem, var(--available-height));
    max-width: var(--available-width);
    overflow: hidden;
    transition:
      opacity 0.1s,
      transform 0.1s;
    transform-origin: var(--transform-origin);
    box-shadow: ${boxShadow};

    /* Keeps the shadow off the trigger. */
    &[data-side='bottom'] {
      clip-path: ${clipPathTop};
    }

    &[data-side='top'] {
      clip-path: ${clipPathBottom};
    }

    &[data-starting-style],
    &[data-ending-style] {
      opacity: 0;
      transform: scale(0.95);
    }
  `,
  HeaderActions: css`
    display: flex;
    align-items: center;
    border-top: 1px solid ${colors.monochrome.grey20};
    border-bottom: 1px solid ${colors.monochrome.grey20};

    & > :last-child {
      flex-grow: 1;
    }
  `,
  SelectAllButton: css`
    box-sizing: border-box;
    outline: 0;
    cursor: pointer;
    user-select: none;
    border: none;
    background: transparent;
    text-align: left;
    padding: 0.75rem;
    display: grid;
    gap: 1rem;
    align-items: center;
    grid-template-columns: 1.5rem 1fr;
    font-size: 1rem;
    line-height: 1rem;
    position: relative;
    font-family: inherit;

    &:hover {
      z-index: 0;
      position: relative;
    }

    &:hover::before,
    &:focus-visible::before {
      content: '';
      z-index: -1;
      position: absolute;
      inset-block: 0;
      inset-inline: 1px;
      border-radius: 0;
      background-color: ${colors.background.grey};
    }
  `,
  ItemIndicator: css`
    grid-column-start: 1;
  `,
  ItemText: css`
    grid-column-start: 2;
  `,
  Empty: css`
    &:not(:empty) {
      font-size: 0.925rem;
      line-height: 1rem;
      padding: 1rem;
      text-align: center;
    }
  `,
  List: css`
    box-sizing: border-box;
    flex: 1 1 auto;
    min-height: 0;
    overflow: hidden;
    outline: 0;

    &[data-empty] {
      padding: 0;
    }
  `,
  VirtualizedGroupItem: css`
    display: block;
    outline: 0;
  `,
  VirtualizedHeader: css`
    position: absolute;
    inset: 0 0 auto 0;
    z-index: 1;
    background-color: canvas;
  `,
  VirtualizedEmpty: ({ top }: { top: number }) => css`
    position: absolute;
    top: ${top}px;
    inset-inline: 0;
  `,
  Scroller: ({ totalSize }: { totalSize: number }) => css`
    box-sizing: border-box;
    height: min(23rem, ${totalSize}px);
    max-height: 100%;
    overflow: auto;
    overscroll-behavior: contain;
    scroll-padding-block: 0.5rem;
  `,
  VirtualizedPlaceholder: ({ totalSize }: { totalSize: number }) => css`
    width: 100%;
    position: relative;
    height: ${totalSize}px;
  `,
  VirtualizedRows: css`
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
  `,
  VirtualizedRow: css`
    width: 100%;
  `,
};
